let filterChangeObserver;
let swatchInitPending = false;
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function waitForEl(selector, timeout = 500, maxTimeout = 10000) {
  const startTime = Date.now();

  while (Date.now() - startTime < maxTimeout) {
    const el = document.querySelector(selector);
    if (el) return el;
    await sleep(timeout);
  }

  console.warn(`Elemento ${selector} não encontrado após ${maxTimeout}ms`);
  return null;
}

async function initSwatches() {
  if (swatchInitPending) return;
  swatchInitPending = true;

  try {
    console.log('Aguardando swatches estarem prontos...');
    const swatch = await waitForEl('.swatch-selector[type="image"]');

    if (!swatch) {
      console.warn('Swatches não encontrados após espera');
      return;
    }

    console.log('Swatches confirmados no DOM - iniciando atualização');

    const swatches = document.querySelectorAll('.swatch-selector[type="image"]');
    swatches.forEach((sw) => {
      const newSw = sw.cloneNode(true);
      sw.parentNode.replaceChild(newSw, sw);
    });

    document.querySelectorAll('.swatch-selector[type="image"]').forEach((sw) => {
      sw.addEventListener('click', function () {
        document
          .querySelectorAll('.swatch-selector.swatch-selected')
          .forEach((el) => el.classList.remove('swatch-selected'));
        this.classList.add('swatch-selected');
        updateSelectedColor(this);
      });
    });

    const initialSelected = document.querySelector('.swatch-selector.swatch-selected');
    if (initialSelected) updateSelectedColor(initialSelected);
  } catch (error) {
    console.error('Erro na inicialização:', error);
  } finally {
    swatchInitPending = false;
  }
}

function updateSelectedColor(swatch) {
  const productCard = swatch.closest('.card-wrapper');
  if (!productCard) return;

  const colorElement = productCard.querySelector('.card__selected-color');
  if (!colorElement) return;

  colorElement.textContent = swatch.getAttribute('data-value');
}

function setupFilterObserver() {
  if (filterChangeObserver) filterChangeObserver.disconnect();

  filterChangeObserver = new MutationObserver(async (mutations) => {
    if (!window.location.search.includes('filter.') && !window.location.search.includes('sort_by')) return;

    await new Promise((resolve) => setTimeout(resolve, 50));

    if (!document.querySelector('.swatch-selector[type="image"].swatch-selected')) {
      await initSwatches();
    }
  });

  filterChangeObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
}

async function initializeAll() {
  // Primeira carga
  await initSwatches();

  setupFilterObserver();

  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    setTimeout(initSwatches, 100);
  };
}

document.addEventListener('DOMContentLoaded', initializeAll);
document.addEventListener('shopify:section:load', initializeAll);
document.addEventListener('shopify:section:reorder', initializeAll);

if (document.readyState !== 'loading') {
  initializeAll();
}
